// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"365":"venue","535":"login","942":"not-found"}[chunkId] || chunkId) + "." + {"211":"26299183","365":"96f278e5","535":"775de677","537":"5240b42d","942":"f26dccf1"}[chunkId] + ".js";
};